import { render } from "./ExplorePackages.vue?vue&type=template&id=38fc58b6&scoped=true"
import script from "./ExplorePackages.vue?vue&type=script&lang=js"
export * from "./ExplorePackages.vue?vue&type=script&lang=js"

import "./ExplorePackages.vue?vue&type=style&index=0&id=38fc58b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38fc58b6"]])

export default __exports__